import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../shared/ProductCard";

const BestProducts = ({ style, title, to, products = [] }) => {
  if (!products.length) return null;

  return (
    <section className={style.productsContainer}>
      <div className={style.sectionHead}>
        <h2>{title}</h2>
        <Link to={to}>Shiko të gjitha</Link>
      </div>
      <div className={style.productGrid}>
        {products.map((product) => (
          <ProductCard product={product} key={product.id} />
        ))}
      </div>
    </section>
  );
};

export default BestProducts;
